import script from "./SignUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./SignUp.vue?vue&type=script&setup=true&lang=ts"

import "./SignUp.vue?vue&type=style&index=0&id=31046622&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31046622"]])

export default __exports__